import axios from "axios";
import TokenService from "../utils/TokenService";

const REFRESH_RETRY_ATTEMPTS = 3;
const REFRESH_RETRY_DELAY_MS = 4000;

const refreshTokenApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_AUTH_HOST}/api/v1`,
    withCredentials: true,
    timeout: 10000,
    headers: {
        "Content-type": "application/json",
    },
});

let isRunning = false;
class RefreshToken {
    wait() {
        return new Promise((resolve) => {
            setTimeout(resolve, 1000);
        });
    }

    delay(ms) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }

    isTransientRefreshError(error) {
        if (!error.response) {
            return true;
        }
        const status = error.response.status;
        return status === 502 || status === 503 || status === 504;
    }

    async getAccessToken() {
        if (isRunning) {
            while (isRunning) {
                await this.wait();
                if (!isRunning) {
                    return;
                }
            }
        }
        isRunning = true;
        try {
            await this.getNewToken();
        } finally {
            isRunning = false;
        }
    }

    async getNewToken() {
        for (let attempt = 1; attempt <= REFRESH_RETRY_ATTEMPTS; attempt++) {
            try {
                const data = await refreshTokenApi.get("auth/refresh");
                TokenService.setAccessToken(data.data.userAccessToken);
                TokenService.setRefreshToken(data.data.userRefreshToken);
                return true;
            } catch (error) {
                if (!this.isTransientRefreshError(error)) {
                    window.location.href = process.env.REACT_APP_ID_SITE + "/logout";
                    return false;
                }
                if (attempt === REFRESH_RETRY_ATTEMPTS) {
                    console.error('Token refresh failed after transient network errors', error);
                    return false;
                }
                await this.delay(REFRESH_RETRY_DELAY_MS);
            }
        }
        return false;
    }
}
export default new RefreshToken();
